import React from 'react'

const notFound = (props) => {
    return (
        <div>
            <h1>404 page not found</h1>
            <p>no match for {props.location.pathname}</p>
        </div>
    )
}

export default notFound;
